module.exports = __webpack_public_path__ + "static/media/marvel-logo.89792186.png";